import { SortInfo } from '~/utils/jsonapi-query';
import { FlowWithDocument } from './flow';
import { MetaDataCursorPage } from './jsonapi';
import { Transaction } from './transaction';

export const ReconciliationsQueryKeys = {
  single: (id: Reconciliation['id']) => ['Reconciliations', id],
  all: ['Reconciliations'],
  companyInfinityList: (
    companyId: string,
    filters: ReconciliationsQueryFilters,
    sorting: SortInfo<ReconciliationsQuerySorting>,
  ) => ['Reconciliations', { companyId }, 'Infinite', filters, sorting],
};

export interface ReconciliationsMeta {
  page: MetaDataCursorPage;
}

export enum ReconciliationRelationStatus {
  REJECTED = 'REJECTED',
  VERIFIED = 'VERIFIED',
}

export type ReconciliationsQuerySorting = 'createdAt';

export enum ReconciliationSource {
  MANUAL = 'MANUAL',
  AUTOMATIC = 'AUTOMATIC',
  PROPOSAL = 'PROPOSAL',
  PAYMENT = 'PAYMENT',
  API = 'API',
}

export enum ReconciliationSourceProps {
  ACCOUNTANT = 'ACCOUNTANT',
}

export interface Reconciliation {
  id: string;
  status: ReconciliationRelationStatus;
  source: ReconciliationSource;
  sourceProps?: string;
  flow?: FlowWithDocument;
  transaction?: Transaction;
  createdAt: string;
}

export interface ReconciliationsFiltersFields {
  dateRange: [string | null, string | null];
  sources: ReconciliationSource[];
}

export interface ReconciliationsQueryFilters {
  ids?: Reconciliation['id'];
  createdAt?: [string | null, string | null];
  sources?: ReconciliationSource[];
  statuses?: ReconciliationRelationStatus[];
}

export interface ReconciliationsMeta {
  page: MetaDataCursorPage;
}
